module.exports = __webpack_public_path__ + "static/media/Piercing-microdermal-nape.426397a3.png";